import React, { Component } from 'react';
import FormularioContactoForm from './FormularioContactoForm';

class FormularioContactoModal extends Component {
    componentDidMount() {
        /* eslint-disable */
        $.HSCore.components.HSModalWindow.init('[data-modal-target]');
    }

    render() {
        const { asunto } = this.props;
        return (
            <div id="contacto-modal" className="text-left g-bg-white g-overflow-y-auto g-pa-20" style={{ display: 'none' }}>
                <button type="button" className="close" onClick={Custombox.modal.closeAll}>
                    <i className="hs-icon hs-icon-close"></i>
                </button>
                <h4 className="g-mb-20">Formulario Contacto</h4>
                <FormularioContactoForm asunto={asunto} />
            </div>
        );
    }
}

export default FormularioContactoModal;



// WEBPACK FOOTER //
// ./src/subcomponents/FormularioContactoModal.js